module.exports = __webpack_public_path__ + "img/pd-img-head3.95a10dd2.png";